export default __webpack_public_path__ + "static/media/logo.931b8213.png";